<app-firsty-loader [isLoading]="isLoading"></app-firsty-loader>

<div class="container-fluid">
    <div class="row">
        <div class="col">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
